import script from "./StatDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatDetailView.vue?vue&type=script&setup=true&lang=js"

import "./StatDetailView.vue?vue&type=style&index=0&id=1da8ac8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da8ac8e"]])

export default __exports__